// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import store from './store'
import '@/assets/styles/index.css'
import infiniteScroll from 'element-ui/lib/infinite-scroll'

Vue.use(ElementUI)
Vue.prototype.$axios = axios

// 在开发环境中启用详细日志
if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false
  Vue.config.performance = true
  Vue.config.devtools = true
} else {
  Vue.config.productionTip = false
}

// 添加全局路由监听，用于调试
router.beforeEach((to, from, next) => {
  console.log(`路由跳转: 从 ${from.path} 到 ${to.path}`)
  next()
})

router.afterEach((to, from) => {
  console.log(`路由完成: ${to.path}`)
})

// 使用无限滚动指令
Vue.use(infiniteScroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    console.log('Vue应用已挂载，当前路径:', this.$route.path)
  }
})



// WEBPACK FOOTER //
// ./src/main.js